import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth34: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M141.2,379.3l16.5,50.2,1.4,8.5-.9,6.3-2.3,5.7-2.3,3.3-43.2,32.2-23.9,7.3-13.3-8.1-8.8.8h-15l-6.8-.6-18.1-16.1-3.9-9.5-5.2-3-3.7-4.5-2-5.2-.9-12.9,1.6-11.4,9.9-44s47.9-15.5,120.9,1Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M141.2,379.3l16.5,50.2,1.4,8.5-.9,6.3-2.3,5.7-2.3,3.3-43.2,32.2-23.9,7.3-13.3-8.1-8.8.8h-15l-6.8-.6-18.1-16.1-3.9-9.5-5.2-3-3.7-4.5-2-5.2-.9-12.9,1.6-11.4,9.9-44s47.9-15.5,120.9,1Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.3,378.3s47.7-15.5,120.9,1l-2.6-8.6s-66.1-19.8-116.7-.6l-1.6,8.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M16.6,394.2l29-.2s10.5-.1,10.5,12.7l-.2,79.6h-13l-18.7-17.6-3.5-8.8-6.8-4.8-4-7.1-1.3-8.4,8.1-45.3Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M146.6,395.4l-33.5-.2s-9.7-.1-9.7,12.7l1.2,80.4,6.4-1.9,30-23.9,9-5.6,4.5-3.5,2.9-6.6,1.2-5.6.8-3.5-4.5-18.7-8.2-23.4Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M104.5,453.5l-1.2-45.6c0-12.9,9.7-12.7,9.7-12.7l33.5.2-5.3-16.1s-62.1-16.9-120.9-1l-3.7,15.9,29-.2s10.5-.4,10.5,12.7-.2,47.1-.2,47.1l48.7-.3Z',
			},
			[ToothSurface.LingualCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '55.9 453.8 104.5 453.8 154 453.8 140.2 463.5 118.8 480.4 110.7 485.9 86.6 493.6 72.6 484.8 64.5 486.4 49.7 486.4 43.9 485.5 24.5 469.1 21.1 460.5 13.3 454.5 55.9 453.8',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'11.4 437.3 30 416.8 34.4 450.3 48.9 410.4 59.8 450.3 73.5 408.4 85.9 447.9 99.3 408.4 111.3 448.3 124.4 408.4 134.4 447.3 141.9 415.3 156.8 438.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'104.8 53.6 87.7 72.2 102 81.6 85.9 89.9 100.2 99.5 83.8 107.9 98.2 117.3 82.5 125.4 97.9 135.6 81.9 143.7 96.5 153.3 81.4 161.1 97.6 171.6 81.7 179.8 95.2 188.8 78.2 197.6 93 207.3 77.9 215 92.9 224.8 78.4 232.4 93.6 242.4 78.5 250.1 91.5 258.6 79 265.1 92.3 273.9 79 280.6 92.3 289.4 78.1 296.6 90.7 304.9 77.7 311.5 90.3 319.7 74.1 328 86.9 336.5 72.8 343.7 86 352.5 70.3 360.6 84.2 369.8 67.2 378.5 81 387.6',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'38.2 246.7 46.9 233.8 55.2 247.1 65.1 232.5 75.3 247.1 83.7 231.8 92.9 244.6 100.6 233.8 107.1 245.5 113.4 232.5 118.6 245',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '28.9 79.7 57.5 48.8 71.2 39.6 87.5 34.3 110 33.4 129.7 40 149.1 55.2 159.2 73.9 163.4 92.1 164.7 112.6 162.3 123.6 153.5 143.4 141.4 156.2 115.8 168.3 95.1 172.5 79.6 172.8 60.7 167.7 36.6 153.3 23.1 135 18.5 116.8 20.1 98 28.9 79.7',
			},
			[ToothSurface.LingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.3,70.8l15.2-17.6,17.2-12.3,19.3-6.9,23-.4,20.9,6.4,17.6,15.2,8.8,15.3-13.7,13.6s-7.9,9-13.5,9c-17.5,0-23.8-8.4-35.4-8.4s-15.9,8.2-28.2,8.2-15.9-7.5-15.9-7.5l-15.3-14.6Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M157.6,137l-6.5,10.8-9.5,8.6-23.6,12.5-19.1,3.7-20.4-.4-19.6-6.2-22.4-13.1-8.4-12.2,19.6-18.7s7.9-9,13.5-9c17.5,0,23.8,8.4,35.4,8.4s15.9-8.2,28.2-8.2,15.9,7.5,15.9,7.5l16.9,16.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.3,70.8l-9.2,12.2-6.7,13.7-1.3,15.5.6,10.1,2.6,10.7,5.8,7.9,19.6-18.7s14.4-13.3,3.9-36.7l-15.3-14.6Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M158.3,70.5l3.6,12.2,2.1,10.5.7,5.2.2,15.3-2.4,8.4-1.1,6.5-3.6,8.3-16.9-16.2s-11.2-15.5,3.9-36.7l13.7-13.6Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.7,85.4s8.4,7.5,15.9,7.5,17.2-8.2,28.2-8.2,17.6,8.4,35.4,8.4,13.5-9,13.5-9c0,0-14.8,17.8-3.9,36.7,0,0-7.9-7.5-15.9-7.5-12.7,0-15.2,8.2-28.2,8.2s-16.3-8.2-35.4-8.4-13.5,9-13.5,9c0,0,14.4-13.7,3.9-36.7Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23,133.7s65.5,20.9,135.4,0l-4.4,9.7-12.6,12.9-25.1,12.3-19.5,4.2-15.7.2-9.5-1.9-11.1-3.7-23.5-13.7-14.2-19.9Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.7,64.8l14.2-15.7,14.5-8.9,17.3-5.9,23.7-.8,18.5,5.3,17.6,13.9,7.5,12.1s-55.1-10.6-113.2,0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'22.5 101 40.3 120.6 44.6 88.6 58.4 126.8 69 88.6 81.8 128.8 93.8 91 106.7 128.8 118.2 90.5 130.7 128.8 140.2 91.5 147.4 122 161.7 100.1',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.7,131.3l-11-57.9-.4-7.5,1.1-6.5,2.8-7.4,22.1-14.4,16-12.7,29.7-12.6,26,9.3,37.8,31.3,9.8,9.6,7.6,11.3-.2,12.3-1.9,7.7-16.6,42.9c-55.5,42.7-122.8-5.3-122.8-5.3Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.7,131.3s67.1,48,122.8,5.3l-6.2,15.4s-46.8,36.1-114.3-7.6l-2.4-13.1Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.7,131.3s67.3,48,122.8,5.3l9.3-23.3h-29.9s-13-2.1-13-13.6v-39.8h-50.9s0,38.8,0,38.8c0,0,1,15.1-12.4,15.1h-29.3l3.4,17.6Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M60,59.9V19.9l-21.7,16.5-21.7,14.6-4.8,7.6-.2,17.1,6.6,38.1h29.3s12.3,1.2,12.4-15.1,0-38.8,0-38.8Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M110.9,59.9V21.8l38.1,32.8,9.9,9.4,5.4,10.2.2,12.9-10.6,26.2h-29.9s-13-2.1-13-13.6v-39.8Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M60,59.9h94.1l-42-37.2-28.7-11.2-29.7,11.4-14,12.5-23.6,16.2-3.9,8.1s48.8.3,47.9.3Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.7,131.3l-11-57.9-.4-7.5,1.1-6.5,2.8-7.4,22.1-14.4,16-12.7,29.7-12.6,26,9.3,37.8,31.3,9.8,9.6,7.6,11.3-.2,12.3-1.9,7.7-16.6,42.9c-55.5,42.7-122.8-5.3-122.8-5.3Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'14.3 76.7 32.9 97.3 37.4 63.5 52.1 103.9 63.1 63.5 76.8 106 89.3 66.1 103 106 115.2 65.6 128.3 106 138.3 66.6 145.9 98.9 161.1 75.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'92.2 428.4 106 410.2 91.4 403.6 105.4 394.5 90.6 387.7 105 378.4 90.4 371.8 104.2 362.9 88.3 355.9 102.2 346.8 87.5 340.2 100.5 331.6 84.2 324.2 97.9 315.2 84.1 308.9 99.1 299.2 84.1 292.4 97 283.9 81.8 277 94.4 268.8 79 261.7 92.1 253.3 78.9 247.1 89.7 240.2 76.1 234.1 87.7 226.5 74.3 220.4 86.5 212.4 73.8 206.6 85 199.3 72.3 193.5 86.5 184.4 73.3 178.5 85.5 170.5 72.2 164.4 85.9 155.5 71.6 149 86.3 139.3 72.5 133',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'34.8 248.4 43.9 264.6 52.8 248 63.3 266.1 74 248 82.9 266.9 92.7 251.2 100.9 264.6 107.8 249.9 114.3 266.1 120 250.8',
			],
		},
	},
};
